/* @flow */
import MessageDelivery from 'entities/MessageDelivery';
import MessageDeliverySummary from 'entities/MessageDeliverySummary';

export default class ChatMessageDelivery extends MessageDelivery {
  static createFromChatMessage(chatMessage) {
    return new ChatMessageDelivery({
      message_type: 'chat',
      message_uuid: chatMessage.id,
      read_summary: new MessageDeliverySummary(chatMessage.getReadSummary()),
      stream_uuid: chatMessage.getChatId(),
    });
  }
}



// WEBPACK FOOTER //
// ./src/entities/ChatMessageDelivery.js